import React, { useEffect, useState } from "react";
import "./NoEffortPage.scss";
import { useLocation } from "react-router-dom";
import NoEffortReason from "../../components/NoEffortReason";
import { connect } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import TripReviewRedirect from "../../components/TripReviewRedirect";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

const NoEffortPage = (props) => {
  useScrollToTop();

  const { vtrTrip, validations, actions } = props;
  const location = useLocation();
  const [noEffortReason, setNoEffortReason] = useState([]);

  useEffect(() => {
    if (validations.validations.activity) {
      const activity = [...validations.validations.activity];
      const activityFiltered = activity.filter(
        ({ KEY }) => KEY !== 4 && KEY !== 5
      );
      setNoEffortReason([...activityFiltered]);
    }
  }, [validations.validations.activity]);

  if (vtrTrip.redirect) {
    return (
      <TripReviewRedirect
        trip_id={location.state.trip_id}
        client_id={location.state.client_id}
      />
    );
  }
  return (
    <div className="NoEffortPage" data-testid="NoEffortPage">
      <NoEffortReason
        no_effort_trip_reason={noEffortReason}
        handleClick={NoEffortClick}
        client_id={location.state.client_id}
        action={actions}
        trip_id={location.state.trip_id}
      />
    </div>
  );
};

const NoEffortClick = function (event, actions) {
  event.preventDefault();
  let { newValue, clientId, tripId } = event.currentTarget.dataset;
  let updateTripObject = { no_effort_trip_reason: newValue };
  if (newValue === "0") {
    //Trip with effort
    //unlikely to be selected....
    actions.updateTrip(updateTripObject, clientId, tripId);
  }
  if (newValue && newValue !== "0") {
    //trip with no effort
    actions.setTripNoEffortReason(updateTripObject, clientId, tripId);
  }
};

export default connect(mapVtrStateToProps, mapDispatchToProps)(NoEffortPage);
